export type TypedValuePrimitive = { $type: string; $value: any };
export type TypedValueArray = { $type: string; $values: any[] };
export type TypedValue = TypedValuePrimitive | TypedValueArray;

export function isTypedValue(value: any): value is TypedValue {
    return isTypedObject(value) && ('$values' in value || '$value' in value);
}

export function isTypedObject(value: any): value is { $type: string } {
    return Object.isObject(value) && '$type' in value;
}

/**
 * function return true only for object not array, function, Number, String, Date
 * @param value
 */
export const isRefObject = _.overEvery(
    Object.isObject,
    _.negate(_.overSome([_.isDate, _.isString, _.isNumber, _.isArray, _.isBoolean, _.isFunction, isTypedValue]))
);
